import { fCurrency } from '@norma/shared/helpers/formatNumber';
import {
  ListeProjectionAgrementRow,
  PrejudiceFormListeProjection,
} from '@norma/shared/types/prejudice.type';
import { Table } from 'docx';
import i18next from 'i18next';
import { displayNumeroPiece } from 'src/helpers/prejudices/numeroPiece';
import { prejudiceFormTable } from 'src/helpers/print/prejudicesPrints/prejudiceFormTablePrint';

export const prejudiceAgrementPrint = ({
  formData,
}: {
  formData: PrejudiceFormListeProjection;
}): Table[] | undefined => {
  return (
    formData.prejudiceValues?.rows &&
    prejudiceFormTable(
      formData.prejudiceValues.rows as ListeProjectionAgrementRow[],
      [
        {
          name: 'numerosPieces',
          headerLabel: i18next.t('numeroPiece.form.columnHeader'),
          render: (row) =>
            row.numerosPieces ? displayNumeroPiece(row.numerosPieces) : '',
        },
        {
          name: 'typePrejudice',
          headerLabel: i18next.t(
            'prejudice.prejudicesFormTypes.LISTE_PROJECTION.PREJUDICE_MALADIE.fields.rows.maladie.columnHeader',
          ),
        },
        {
          name: 'montant',
          headerLabel: i18next.t(
            'prejudice.prejudicesFormTypes.LISTE_PROJECTION.PREJUDICE_AGREMENT.fields.rows.montant.columnHeader',
          ),
          render: (row) => fCurrency(row.montant),
        },
      ],
    )
  );
};
